import { IRoutePageComponent, IRoutePageGetInitialPropsArgs } from './types';

function getInitialProps(
  component: IRoutePageComponent,
  args: IRoutePageGetInitialPropsArgs,
) {
  const isServer = !!args.req;
  let propsPromise: any =
    typeof component.getInitialProps === 'function'
      ? component.getInitialProps({ isServer, ...args })
      : {};

  if (typeof propsPromise.then !== 'function') {
    propsPromise = Promise.resolve(propsPromise);
  }

  return propsPromise.catch((error) => {
    console.error(error);
    return { error };
  });
}

export default getInitialProps;
